import React from "react";

import EditIcon from "@uui/Edit05";

import {
  FloatingNavActionDivider,
  FloatingNavButton,
} from "@app/analytics/components/reports/FloatingNav";
import { EDITING_TOOLTIP } from "@app/analytics/MeetingReport/constants";
import type {
  EditAccessLevel,
  RecapMainSection,
} from "@app/analytics/MeetingReport/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu from "@rui/Menu";
import MenuItem from "@rui/MenuItem";
import TooltipWrapper from "@rui/TooltipWrapper";

const EditButton = ({
  editAccessLevel,
  onClickEditSection,
}: {
  editAccessLevel: EditAccessLevel;
  onClickEditSection: (section: RecapMainSection) => void;
}) => {
  const { open, onClick, anchorEl, onClose } = useAnchorElement();

  if (editAccessLevel === "none") return null;

  const handleSelectSection: typeof onClickEditSection = (section) => {
    onClickEditSection(section);
    onClose();
  };

  const cannotEditTranscript = editAccessLevel !== "full";

  return (
    <>
      <FloatingNavActionDivider />
      <FloatingNavButton Icon={EditIcon} onClick={onClick}>
        Edit
      </FloatingNavButton>
      <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
        <MenuItem onClick={() => handleSelectSection("notes")}>
          Edit Notes
        </MenuItem>
        <TooltipWrapper
          title={EDITING_TOOLTIP.cannotEditSection}
          show={cannotEditTranscript}
        >
          <MenuItem
            disabled={cannotEditTranscript}
            onClick={() => handleSelectSection("transcript")}
          >
            Edit Transcript
          </MenuItem>
        </TooltipWrapper>
      </Menu>
    </>
  );
};

export default EditButton;
